import template from './BlipSmartView.html';
import './BlipSmart.scss';
export const BlipSmartComponent = {
    template,
};
